module.exports = "/_next/static/images/BuildDeeper@2x-5ed4bd7071bdd05bc9215ed6d1d91895.webp";